<section>
	<form #conditionsForm="ngForm" (ngSubmit)="onSubmitConditions()">
		<p-dialog [(visible)]="displayModal" [modal]="true" [breakpoints]="{'960px': '100vw'}"
			[style]="{width: '70vw'}" [draggable]="false" [resizable]="true" [maximizable]="true">
			<ng-template pTemplate="header">
				<CustomTitle [title]="'components.app-condition-builder.title' | translate" />
			</ng-template>

			<ng-template pTemplate="content">
				<div class="flex flex-column gap-2 p-fluid">
					<div *ngFor="let token of tokens; let i = index">
						<div class="flex gap-2 align-items-start">
							<div *ngIf="i===0" class="align-self-center">
								If
							</div>
							<div *ngIf="i!==0">
								<p-dropdown name="operator{{i}}" [(ngModel)]="token.operator" [options]="operatorList" appendTo="body"
									placeholder="Select..." required [class.ng-invalid]="conditionsForm.submitted && !token.operator"
									[class.ng-dirty]="conditionsForm.submitted && !token.operator"></p-dropdown>
							</div>
							<div>
								<p-dropdown name="variable{{i}}" [(ngModel)]="token.controlName" [options]="variableList" appendTo="body"
									placeholder="Select..." filter="true" required
									[class.ng-invalid]="conditionsForm.submitted && !token.controlName"
									[class.ng-dirty]="conditionsForm.submitted && !token.controlName"
                  (onChange)="onVariableChange(token)">
								</p-dropdown>
							</div>
							<div>
								<p-dropdown name="condition{{i}}" [(ngModel)]="token.condition" [options]="getConditionList(token.controlName)" appendTo="body"
									placeholder="Select..." required [class.ng-invalid]="conditionsForm.submitted && !token.condition"
									[class.ng-dirty]="conditionsForm.submitted && !token.condition"></p-dropdown>
							</div>
							<div *ngIf="token.condition !== 'empty' && token.condition !== 'notEmpty'">
								<input name="value{{i}}" [(ngModel)]="token.value" type="text" pInputText required
									[class.ng-invalid]="conditionsForm.submitted && !token.value"
									[class.ng-dirty]="conditionsForm.submitted && !token.value" />
							</div>
							<div *ngIf="tokens.length > 0" class="align-self-center">
								<button pButton type="button" icon="pi pi-trash" class="p-button-danger p-button-outlined p-button-lg"
									(click)="removeToken(i)"></button>
							</div>
						</div>
					</div>
					<div *ngIf="tokens[0]?.operator && tokens[0]?.controlName && tokens[0]?.condition">
						<button pButton type="button" [label]="'components.app-condition-builder.add-condition' | translate" class="p-button-outlined p-button-success button-edit"
							(click)="addToken()"></button>
					</div>
				</div>
			</ng-template>

			<ng-template pTemplate="footer">
				<div class="field col-12">
					<div class="flex justify-content-between">
						<button pButton type="button" [label]=" 'form.button.cancelar' | translate" class="tax-app-button " (click)="closeModal()"></button>
						<button pButton type="submit" [label]=" 'form.button.aplicar' | translate" icon="pi pi-save" class="tax-app-button "></button>
					</div>
				</div>
			</ng-template>
		</p-dialog>
	</form>
</section>

<p-table *ngIf="Control" [value]="currentTokens" styleClass="p-datatable-sm" [scrollable]="true"
	scrollHeight="250px">
	<ng-template pTemplate="body" let-condition let-ri="rowIndex">
		<tr>
			<td>
				<div class="flex gap-2 align-items-center">
					<div *ngIf="ri===0">
						<b>If</b>
					</div>
					<div *ngIf="ri!==0">
						<p-chip [label]="condition.operator" styleClass="operator-chip"></p-chip>
					</div>
					<div class="align-self-center">
						<b>"{{condition.controlName}}"</b>
					</div>
					<p-chip [label]="getConditionText(condition.controlName, condition.condition)" styleClass="condition-chip"></p-chip>
					<p *ngIf="condition.value && condition.value !== '' ">
						"{{condition.value}}"
					</p>
				</div>
			</td>
		</tr>
	</ng-template>
</p-table>